import { TaxTypeEnum } from 'src/content/Taxes/enums/TaxTypeEnum'

export const selectAllTaxes = state => state.taxes.taxes

const taxToItems = [TaxTypeEnum.GRAVABLE, TaxTypeEnum.EXEMPT]
export const selectAllTaxesActive = state =>
  state.taxes.taxes?.filter((tax: Tax) => tax.active && taxToItems.includes(tax.type))

export const selectAllTaxesRetention = state =>
  state.taxes.taxes
    ?.filter((tax: Tax) => tax.type === TaxTypeEnum.ISR_RETENTION && tax.active)
    .map((tax: Tax) => ({
      ...tax,
      value: tax.rate,
      label: tax.name,
    }))
